module.exports = __webpack_public_path__ + "static/media/multiply_btc.09f3cb21.png";